import { noop } from "lodash-es";

import { interpolate } from "@/math/coordinates";
import { moveAnimationDelay, moveAnimationStep } from "@/model/Settings";
import type { IdMap } from "@/model/baseTypes";
import type { BoardCard } from "@/model/card";
import type { RelativeCoordinate } from "@/model/coordinates";

export function animateCardMove(
  card: BoardCard | undefined,
  coord: RelativeCoordinate,
  moveFn: (c: RelativeCoordinate) => void,
  endFn?: () => void,
) {
  if (card) {
    animations[card.data.id] = {
      from: card.meta.pos,
      to: coord,
      moveFn,
      endFn: endFn || noop,
      t: 0,
    };
  }
}

export function animateLinkMove(
  card: BoardCard,
  coord: RelativeCoordinate,
  moveFn: (c: RelativeCoordinate) => void,
  endFn: () => void,
) {
  animations[card.data.id] = { from: coord, to: { ...card.meta.pos }, moveFn, endFn, t: 0 };
}

export function clear() {
  for (const id in animations) {
    delete animations[id];
  }
}

interface Animation {
  from: RelativeCoordinate;
  to: RelativeCoordinate;
  moveFn: (c: RelativeCoordinate) => void;
  endFn: () => void;
  t: number;
}

const animations: IdMap<Animation> = {};

animate();

function animate() {
  for (const id in animations) {
    const d = animations[id];
    d.t += moveAnimationStep;
    d.moveFn(interpolate(d.t, d.from, d.to));
    if (d.t >= 1) {
      d.endFn();
      delete animations[id];
    }
  }
  setTimeout(animate, moveAnimationDelay);
}
